import { Link, Outlet } from "react-router-dom";
import productsData from "../data/productsData";
// 1. Import the new unified CSS module
import styles from "./product.module.css";

export function Products() {
    return (
        // 2. Apply the consistent page wrapper for the animated background
        <div className={styles.pageWrapper}>
            <div className={styles.contentWrapper}>
                <header className={styles.header}>
                    <h1 className={styles.pageTitle}>Our Products</h1>
                    <p className={styles.pageSubtitle}>
                        Explore our cutting-edge semiconductor solutions designed for the future of AI.
                    </p>
                </header>

                {/* 3. Main content area */}
                <main className={styles.mainContent}>
                    {/* The Outlet will render the selected product's details here */}
                    <div className={styles.outletContainer}>
                        <Outlet />
                    </div>

                    {/* Links to Product Categories */}
                    <nav>
                         <h2 className={styles.categoryTitle}>Product Categories</h2>
                        <ul className={styles.categoryGrid}>
                            {productsData.map((product) => (
                                <li key={product.id}>
                                    <Link to={product.id} className={styles.categoryCard}>
                                        {product.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </main>
            </div>
        </div>
    );
}
